"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  QueryState: true,
  parseAsJson: true
};
Object.defineProperty(exports, "QueryState", {
  enumerable: true,
  get: function () {
    return _QueryState.QueryState;
  }
});
Object.defineProperty(exports, "parseAsJson", {
  enumerable: true,
  get: function () {
    return _parsers.parseAsJson;
  }
});
var _QueryState = require("./contexts/QueryState");
var _parsers = require("./utils/parsers");
var _nuqsWrapper = require("./nuqs-wrapper");
Object.keys(_nuqsWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _nuqsWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _nuqsWrapper[key];
    }
  });
});
